import LeftShape from '@/assets/images/free-trial-shape-left.png';
import RightShape from '@/assets/images/free-trial-shape-right.png';
import TopShape from '@/assets/images/free-trial-shape-top.png';
import { useAuth } from '@/providers/AuthProvider';
import clsx from 'clsx';
import { freeTrialMailtoHref } from '@/utils/freeTrial';

export default function FreeTrialBanner({ smallVersion = false }: { smallVersion?: boolean }) {
  const { organization } = useAuth();

  if (!organization?.onFreeTrial) {
    return <></>;
  }

  // Default to showing some days if we don't have the data yet
  const daysText = organization.freeTrialDaysRemaining;
  const dayLabel = organization.freeTrialDaysRemaining === 1 ? 'day' : 'days';

  return (
    <div
      className={clsx(
        'rounded-xs bg-accent-2-100 relative shrink-0 free-trial-banner',
        !smallVersion && 'px-100 py-16 w-full mb-55',
        smallVersion && 'px-80 py-8 w-564'
      )}
    >
      <h4
        className={clsx(
          'z-100 relative',
          !smallVersion && 'text-h4',
          smallVersion && 'text-body-sm font-bold '
        )}
      >
        You have{' '}
        <span className="text-primary-500 font-bold">
          {daysText} {dayLabel}
        </span>{' '}
        left in your free trial!
        <a
          href={freeTrialMailtoHref}
          className={clsx(
            'btn btn-neutral btn-sm',
            !smallVersion && 'ml-16',
            smallVersion && 'ml-12'
          )}
        >
          Contact Scribl
        </a>
      </h4>
      <div className="absolute w-full h-full top-0 left-0 rounded-xs z-0">
        <img src={LeftShape} className="absolute h-7/10 top-0 rounded-l-xs" />
        <img src={RightShape} className="absolute h-full bottom-0 right-0 rounded-r-xs" />
        <img src={TopShape} className="absolute h-6/10 top-0 right-2/10 z-0" />
      </div>
    </div>
  );
}
